import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import ResultsSlider from '@components/acca/results/common/resultsSlider';
import EmptyResult from '@components/phs/pacc/results/resultList/emptyResult';
import PhsToast from '@components/phs/pacc/results/resultList/PhsToast';
import ResultTab from '@components/phs/pacc/results/resultList/resultTab';
import { useUserInfo } from '@repository/auth/useUserInfo';
import { usePHSApplyHistoryList } from '@repository/phs/apply/usePhsApply';
import { phsAnalysisStatusMap, phsAnalysisTextMap, PHSAnalysisType } from '@domain/constant/phsAnalysisType';

import DateFormat from '@utils/date/format';
import classnames from 'classnames/bind';
import styles from './resultList.module.scss';
const cx = classnames.bind(styles);

interface ResultItemProps {
  analysisType: PHSAnalysisType;
  dateTime: string;
  onClick: () => void;
  isOn: boolean;
}

const ResultItem = ({ analysisType, dateTime, onClick, isOn }: ResultItemProps) => {
  const type = phsAnalysisStatusMap[analysisType];
  const badge = phsAnalysisTextMap[analysisType];
  const viewDateTime = DateFormat.format(new Date(dateTime), 'yyyy.MM.dd HH:mm');

  return (
    <a className={cx('btnResult', { on: isOn })} role="button" onClick={onClick}>
      <div className={cx('infoArea')}>
        <div className={cx('badgeArea')}>
          <span className={cx('badge', type)}>{badge}</span>
        </div>
        <div className={cx('text')}>결과표 보기</div>
        {dateTime && <span className={cx('dateTime')}>{viewDateTime}</span>}
      </div>
    </a>
  );
};

interface ResultListProps {
  sn: number | null;
  setSn: (sn: number | null) => void;
}

const ResultList = ({ sn, setSn }: ResultListProps) => {
  const { query } = useRouter();
  const { data: userInfo } = useUserInfo();
  const { data: phsApplyResults } = usePHSApplyHistoryList(!!userInfo?.id);
  const length = phsApplyResults?.pstResults?.length ?? 0;
  const isEmpty = length === 0 || !userInfo?.id;

  useEffect(() => {
    if (query.sn && typeof Number(query.sn) === 'number') {
      const querySn = Number(query.sn);
      setSn(Number(querySn));
    }
  }, [phsApplyResults]);

  const resultItemEls = phsApplyResults?.pstResults?.map((resultRecord) => {
    const { analysisType, endDateTime, applySn } = resultRecord;

    const handleClickResultItem = () => {
      setSn(applySn);
      if (analysisType !== 'COMPLETED') return PhsToast({ type: analysisType });
    };

    const isOn = sn === applySn;

    return (
      <ResultItem
        key={sn}
        analysisType={analysisType}
        dateTime={endDateTime}
        onClick={handleClickResultItem}
        isOn={isOn}
      />
    );
  });

  return (
    <div className={cx('resultListArea')}>
      <ResultTab tab={'PST'} />

      {isEmpty ? (
        <EmptyResult />
      ) : (
        <div className={cx('sliderArea')}>
          <ResultsSlider resultItemEls={resultItemEls} />
        </div>
      )}
    </div>
  );
};

export default ResultList;
